
























import { Component } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { SelectionInfoTable } from '@/components/organisms/SelectionInfoTable'
import { NAV_LOADING_END, NAV_LOADING_START } from '@/config/event'
import {
  AlertMessage,
  bibliographyRealApi,
  ErrorMessage,
  OrderSelection
} from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'

export interface ModalSelectionInfoInterface {
  bibliographyRealId: number
  marcNo: string
  onClickLink: (orderCardId: number) => void
}

@Component({
  components: {
    SelectionInfoTable,
    ModalFooter
  }
})
export default class ModalSelectionInfo extends ModalComponentBaseVue {
  dialog: boolean = false

  tableBodyHeight: number = 0

  linkCallback?: (orderCardId: number) => void

  orderSelection: OrderSelection[] = []

  open(params: ModalSelectionInfoInterface): void {
    this.dialog = true
    this.getOrderSelection(params.bibliographyRealId, params.marcNo)
    this.linkCallback = params.onClickLink
    window.addEventListener('resize', this.calculateTableHeight)
    this.$nextTick(this.calculateTableHeight)
  }

  close(): void {
    this.linkCallback = undefined

    this.tableBodyHeight = 0
    window.removeEventListener('resize', this.calculateTableHeight)
    this.dialog = false
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickLink(orderCardId: number): void {
    if (this.linkCallback) {
      this.linkCallback(orderCardId)
    }

    this.close()
  }

  async getOrderSelection(
    bibliographyRealId: number,
    marcNo: string
  ): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.orderSelection = await bibliographyRealApi.getOrderSelection({
        id: bibliographyRealId,
        marcNo
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      this.close()
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }
}
